import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["captchaForm", "submit"]

  connect() {
  }

  loadCaptcha() {
    if (!window.captchaLoaded) {
      window.captchaLoaded = true
      var src = "https://hcaptcha.com/1/api.js"

      loadScript(src, this._renderCaptcha.bind(this));
    } else {
      this._renderCaptcha();
    }
  }

  _renderCaptcha() {
    const siteKey = this.captchaFormTarget.dataset.siteKey;

    window.hcaptcha.render(
      this.captchaFormTarget.id,
      { "sitekey": siteKey, "callback": this._enableFormSubmitButton.bind(this) }
    );
  }

  submitForm(e) {
    e.preventDefault();

    fetch(e.target.dataset.captchaVerifyUrl)
      .then(res => res.json())
      .then(response => {
        if (response["success"] === true) {
          e.target.form.submit();
        } else {
          return alert(this.captchaFormTarget.dataset.captchaErrorMessage)
        }
      });
  }

  _enableFormSubmitButton(responseToken) {
    const captchaVerifyUrlWithToken = this.submitTarget.dataset.captchaVerifyUrl.concat(`&response_token=${responseToken}`)

    this.submitTarget.dataset.captchaVerifyUrl = captchaVerifyUrlWithToken
    this.submitTarget.disabled = false;
  }
}
